import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';

import {
  BEGIN, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';
import { REPORTS_PAGE_MODULE } from '../../configs/moduleNames';

export const LOAD_REPORTS_LIST = '_LOAD_REPORTS_LIST';
export const EXPORT = '_EXPORT';
export const EXPORT_STATUS = '_EXPORT_STATUS';

export const loadReportsList = createDeferredAction(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST);
export const loadReportsListBegin = createAction(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST + BEGIN);
export const loadReportsListSuccessful = createAction(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST + SUCCESSFUL);
export const loadReportsListFailed = createAction(REPORTS_PAGE_MODULE + LOAD_REPORTS_LIST + FAILED);

export const createExport = createDeferredAction(REPORTS_PAGE_MODULE + EXPORT);
export const createExportSuccessful = createAction(REPORTS_PAGE_MODULE + EXPORT + SUCCESSFUL);
export const createExportFailed = createAction(REPORTS_PAGE_MODULE + EXPORT + FAILED);

export const createExportStatus = createDeferredAction(REPORTS_PAGE_MODULE + EXPORT_STATUS);
export const createExportSuccessfulStatus = createAction(REPORTS_PAGE_MODULE + EXPORT_STATUS + SUCCESSFUL);
export const createExportFailedStatus = createAction(REPORTS_PAGE_MODULE + EXPORT_STATUS + FAILED);
